"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagPicker = exports.StyledTag = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Tag = _interopRequireDefault(require("../Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

var TagPicker = exports.TagPicker = _styledComponents["default"].div.withConfig({
  displayName: "styles__TagPicker",
  componentId: "sc-7budtk-0"
})(["display:flex;flex-wrap:wrap;padding:16px 16px 0 16px;"]);
var StyledTag = exports.StyledTag = (0, _styledComponents["default"])(_Tag["default"]).withConfig({
  displayName: "styles__StyledTag",
  componentId: "sc-7budtk-1"
})(["margin:0 16px 16px 0;", ""], function (p) {
  return p.theme.buttonColor === '#ffffff' && "\n    border: 1px solid #000;\n  ";
});
//# sourceMappingURL=styles.js.map